import DashboardContainer from "components/dashboard/DashboardContainer";
import { EstimatedTaxNudgeBanner } from "components/BooksHomePage/EstimatedTaxNudgeBanner/EstimatedTaxNudgeBanner";
import { CATEGORISATION_TYPE } from "constants/booksHomePage";
import { memo } from "react";
import { CashFlow } from "./CashFlow";
import { FinancialHealth } from "./FinancialHealth";

export const BusinessOverview = memo(() => {
  return (
    <DashboardContainer>
      <DashboardContainer.Header className="t-flex t-gap-4 t-flex-col">
        <h5 className="!t-m-0 t-text-subtitle-lg t-text-i-primary-100">
          Business Insights
        </h5>
      </DashboardContainer.Header>
      <div className="t-mt-3">
        <EstimatedTaxNudgeBanner />
      </div>
      <DashboardContainer.Content className="t-mt-4 t-grid t-gap-6 t-grid-cols-1 md:t-grid-cols-2 md:t-min-h-96">
        <CashFlow categorisationType={CATEGORISATION_TYPE.ALL} />
        <FinancialHealth categorisationType={CATEGORISATION_TYPE.ALL} />
      </DashboardContainer.Content>
    </DashboardContainer>
  );
});
